var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showLabels)?_c('div',{style:({
        cursor: 'url(' + _vm.pointerCursor + ', auto',
        height: _vm.imgRescaledSize[1] + 'px', 
        width: _vm.imgRescaledSize[0] + 'px',
        position: 'absolute',
        top: 0, 
        left: 0
        })},_vm._l((_vm.masks),function(item,index){return _c('div',{key:item.position[0]},[(item)?_c('div',{staticClass:"container-fluid"},[_c('svg',{style:({ 
                  position: 'absolute',
                  left: item.position[0] + 'px',
                  top: item.position[1] + 'px',  
                  zIndex: 0,
                }),attrs:{"xmlns":item.xmlns,"height":item.size[1],"width":item.size[0],"viewBox":item.viewBox,"fill":"none"}},[_c('path',{style:({ 
                        pointerEvents: 'all',
                        cursor: 'url(' + _vm.detailCursor + '), pointer'
                        }),attrs:{"fill":"none","d":item.path},on:{"click":function($event){return _vm.toggleMaskVisible(index)},"mouseover":function($event){return _vm.overMask()},"mouseleave":function($event){return _vm.leaveMask()}}})])]):_vm._e()])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }